class SecondaryNavModule {
    constructor(selector) {
        this.selector = selector;
        this.secondaryNavs = document.querySelectorAll(selector);
        this.initSecondaryNav();
        window.addEventListener('resize', this.initSecondaryNav.bind(this));
    }

    initSecondaryNav() {
        this.secondaryNavs.forEach(secondaryNav => {
            this.addArrows(secondaryNav);
            this.horizontalScroll(secondaryNav);
            this.watchScrollPosition(secondaryNav);
            this.centerActiveLink(secondaryNav);
            this.smoothScrollToElement(secondaryNav);
        });
    }

    addArrows(secondaryNav) {
        const listElement = secondaryNav.querySelector('.c-secondary-nav__list');
        if (listElement.scrollWidth > listElement.clientWidth) {
            secondaryNav.classList.add('c-secondary-nav--overflowed');
        } else {
            secondaryNav.classList.remove('c-secondary-nav--overflowed');
        }
    }

    horizontalScroll(secondaryNav) {
        const scrollContent = secondaryNav.querySelector('.c-secondary-nav__list');
        const scrollLeftButton = secondaryNav.querySelector('[data-scroll-left]');
        const scrollRightButton = secondaryNav.querySelector('[data-scroll-right]');
        let scrollInterval;

        function scrollLeft() {
            scrollInterval = setInterval(function () {
                scrollContent.scrollLeft -= 2;
            }, 10);
        }

        function scrollRight() {
            scrollInterval = setInterval(function () {
                scrollContent.scrollLeft += 2;
            }, 10);
        }

        function stopScrolling() {
            clearInterval(scrollInterval);
        }

        scrollLeftButton.addEventListener('click', function (e) {
            e.preventDefault();
        });

        scrollRightButton.addEventListener('click', function (e) {
            e.preventDefault();
        });

        scrollLeftButton.addEventListener('mousedown', function (e) {
            e.preventDefault();
            scrollLeft();
        });

        scrollRightButton.addEventListener('mousedown', function (e) {
            e.preventDefault();
            scrollRight();
        });

        document.addEventListener('mouseup', stopScrolling);
        document.addEventListener('mouseleave', stopScrolling);

        scrollLeftButton.addEventListener('touchstart', function (e) {
            e.preventDefault();
            scrollLeft();
        });

        scrollRightButton.addEventListener('touchstart', function (e) {
            e.preventDefault();
            scrollRight();
        });

        document.addEventListener('touchend', stopScrolling);
        document.addEventListener('touchcancel', stopScrolling);
    }

    watchScrollPosition(secondaryNav) {
        const links = secondaryNav.querySelectorAll('.c-secondary-nav__link');

        function onScroll() {
            const navHeight = secondaryNav.offsetHeight;
            const fromTop = window.scrollY + navHeight + 20;
            const scrollItems = Array.from(links).map(link => {
                const href = link.getAttribute('href');
                const targetId = href && href.substring(1);
                const item = targetId && document.getElementById(targetId);
                if (item) {
                    return {
                        link,
                        item,
                        offsetTop: item.offsetTop,
                        offsetBottom: item.offsetTop + item.offsetHeight
                    };
                }
                return null;
            }).filter(Boolean);

            scrollItems.forEach(scrollItem => {
                if (fromTop >= scrollItem.offsetTop && fromTop < scrollItem.offsetBottom) {
                    scrollItem.link.classList.add('c-secondary-nav__link--active');
                } else {
                    scrollItem.link.classList.remove('c-secondary-nav__link--active');
                }
            });
        }

        window.addEventListener('scroll', onScroll);
    }

    centerActiveLink(secondaryNav) {
        const list = secondaryNav.querySelector('.c-secondary-nav__list');
        let previousActiveLink = null;

        function getActiveLink() {
            const activeLink = secondaryNav.querySelector('.c-secondary-nav__link--active');
            if (activeLink !== previousActiveLink && activeLink !== null) {
                const containerRect = list.getBoundingClientRect();
                const itemRect = activeLink.getBoundingClientRect();

                if (itemRect.left < containerRect.left || itemRect.right > containerRect.right) {
                    const scrollLeft = itemRect.left - containerRect.left - (containerRect.width - itemRect.width) / 2;
                    list.scrollLeft = scrollLeft;
                }
                previousActiveLink = activeLink;
            }
        }

        window.addEventListener('load', getActiveLink);

        let timeout;
        const observer = new MutationObserver(() => {
            clearTimeout(timeout);
            timeout = setTimeout(getActiveLink, 100);
        });

        observer.observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });

        secondaryNav.querySelectorAll('.c-secondary-nav__link').forEach(link => {
            link.addEventListener('click', () => {
                observer.disconnect();
                setTimeout(() => observer.observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] }), 1000);
            });
        });
    }

    smoothScrollToElement(secondaryNav) {
        const navHeight = secondaryNav.offsetHeight;
        const links = secondaryNav.querySelectorAll('.c-secondary-nav__link[href^="#"]');

        links.forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                const targetId = this.getAttribute('href').substring(1);
                const targetElement = document.getElementById(targetId);
                if (targetElement) {
                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: targetPosition - navHeight,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
}

export default SecondaryNavModule;
